import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { convertReq, convertName } from '../../utils/utils';
import { updateWebServiceReq, setWebservicesReq } from '../../../../store/modules/bilsoftSlice';

import { InputText } from 'primereact/inputtext';

export default function WebServicesReq({ req = null, title = null }) {
    const { selectedModule } = useSelector((state) => state.modules);
    const { webServiceReq } = useSelector((state) => state.bilsoft);
    const isInitialized = useRef(false);

    const dispatch = useDispatch();

    useEffect(() => {
        // Only initialize once to prevent infinite loops
        if (!isInitialized.current) {
            if (selectedModule && !req && selectedModule.requirements) {
                dispatch(setWebservicesReq(convertReq(selectedModule.requirements)));
                isInitialized.current = true;
            } else if (req) {
                dispatch(setWebservicesReq(req));
                isInitialized.current = true;
            }
        }
    }, [selectedModule, req, dispatch]);

    const onServiceInputChange = (e, title) => {
        dispatch(updateWebServiceReq({ title, value: e.target.value }));
    };

    return (
        <div className="w-full">
            <div className="mt-5">
                <h3>{title || selectedModule?.title || 'Web Servis Ayarları'}</h3>
                {webServiceReq &&
                    Object.keys(webServiceReq)?.map((req, i) => {
                        return (
                            <div key={i} className="py-3">
                                <div className="w-full mb-2">
                                    <label htmlFor={req}>{convertName(req)}</label>
                                </div>
                                <div className="w-full">
                                    <InputText onChange={(e) => onServiceInputChange(e, req)} placeholder={convertName(req)} value={webServiceReq[req]} className="w-full" />
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
